import { Component, HostListener, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductService } from '../../services/productservice';
import { SearchService } from '../../services/search-service.service';
import * as $ from 'jquery';
import { loadLeafletAssets } from '../@shared/leaflet-loader';
declare var L: any;

@Component({
  selector: 'app-exploreseychelles',
  templateUrl: './explore-seychelles.component.html',
  styleUrls: ['./explore-seychelles.component.scss'],
})
export class ExploreSeychellesComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroy$ = new Subject<void>();
  public options: any;
  public overlays: any = [];
  images: any = ['../../assets/images/home-banner-2.jpg'];
  public categoryTypes: any = [];
  public selectedCats: string[] = [];
  public selectedCatKey = '';
  public selectedSubCatKey = '';
  public selectedCat = { name: '', src: '' };
  public classifications: string;
  public modelPopUp = false;
  public textEnter: string;
  public searchQuery: any;
  public searchSub: Subscription;
  public searchDetails: any = {};
  public results: any[];
  public newserachResults: any = [];
  public popularKeywords: any = [];
  public refFilterResult: any = [];
  public latestSearchCategories: any = [];
  public searchResults: any = [];
  public latLongitude: any = [];
  public lattitude: any = [];
  public longitude: any = [];
  public showMobileSearch = false;
  //public map: google.maps.Map;
  public infoWindow: any;
  public productId: string;
  searchTxt: any = '';
  subCat: any = {};
  subCatKeys: any = [];
  bannerImg = '../../assets/images/home-banner-2.avif';
  showSearchBox: any = false;
  selectedContent: any = '';
  activeIndex: any;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;
  map: any;
  leafletMarks: any = [];
  markers: any[] = [];
  subCatNames: any[] = [
    {
      ProductTypeId: 'GUESTHOUSE',
      Description: 'Guesthouses',
      ProductCategory: 'ACCOMM',
    },
    {
      ProductTypeId: 'HOTEL',
      Description: 'Hotels',
      ProductCategory: 'ACCOMM',
    },
    {
      ProductTypeId: 'RESORT',
      Description: 'Resorts',
      ProductCategory: 'ACCOMM',
    },
    {
      ProductTypeId: 'SELFCATERING',
      Description: 'Self Catering',
      ProductCategory: 'ACCOMM',
    },
    {
      ProductTypeId: 'AMUSETHEME',
      Description: 'Amusement and Theme Parks',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'ENTERTAIN',
      Description: 'Entertainment Venues',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'GALMUSECOL',
      Description: 'Galleries, Museums and Collections',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'HISTHERITG',
      Description: 'Historical Sites and Heritage Locations',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'LMARKBLD',
      Description: 'Landmarks and Buildings',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'NATPARKRES',
      Description: 'National Parks and Reserves',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'NATATTRACT',
      Description: 'Natural Attractions',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'PKGDNCEM',
      Description: 'Parks and Gardens',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'SHOPPING',
      Description: 'Shopping and Markets',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'SPARETREAT',
      Description: 'Spas and Retreats',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'SPORTREC',
      Description: 'Sports and Recreation Facilities',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'ZOOSNCAQU',
      Description: 'Zoos, Sanctuaries, Aquariums and Wildlife Parks',
      ProductCategory: 'ATTRACTION',
    },
    {
      ProductTypeId: 'AOTOURS',
      Description: 'Adventure and Outdoors Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'AHBTOURS',
      Description: 'Air, Helicopter and Balloon Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'CSWTOURS',
      Description: 'Cruises, Sailing and Water Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'CTTOURS',
      Description: 'Cultural and Theme Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'FWTOURS',
      Description: 'Food and Wine Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'ANTOURS',
      Description: 'Nature and wildlife',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'NTOURS',
      Description: 'Nightlife Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'SHTOURS',
      Description: 'Shopping Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'CSTOURS',
      Description: 'Sightseeing Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'STOURS',
      Description: 'Sports Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'WBTOURS',
      Description: 'Walking and Biking Tours',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'CUSTOMISED',
      Description: 'Customised',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'EVENING',
      Description: 'Evening',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'EXTENDED',
      Description: 'Extended',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'FULLDAY',
      Description: 'Full Day',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'HALFDAY',
      Description: 'Half Day or Less',
      ProductCategory: 'TOUR',
    },
    {
      ProductTypeId: 'DOMAIRSVC',
      Description: 'Domestic Air Services',
      ProductCategory: 'TRANSPORT',
    },
    {
      ProductTypeId: 'INTAIRSVC',
      Description: 'International Air Services',
      ProductCategory: 'TRANSPORT',
    },
    {
      ProductTypeId: 'BUSSVC',
      Description: 'Bus Services',
      ProductCategory: 'TRANSPORT',
    },
    {
      ProductTypeId: 'COACHSVC',
      Description: 'Coach Services',
      ProductCategory: 'TRANSPORT',
    },
    {
      ProductTypeId: 'FERRYSVC',
      Description: 'Ferry Services',
      ProductCategory: 'TRANSPORT',
    },
    {
      ProductTypeId: 'TAXI',
      Description: 'Taxis',
      ProductCategory: 'TRANSPORT',
    },
    {
      ProductTypeId: 'BEACHES',
      Description: 'Beaches',
      ProductCategory: 'DESTINFO',
    },
    {
      ProductTypeId: 'ISLANDS',
      Description: 'Islands',
      ProductCategory: 'DESTINFO',
    },
    {
      ProductTypeId: 'EVTBUS',
      Description: 'Business Event',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'EVTCLASS',
      Description: 'Classes, Lessons, Workshops and Talks',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'EVTCOMNTY',
      Description: 'Community Event',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'PERFORMANC',
      Description: 'Concert or Performance',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'EXHIBIT',
      Description: 'Exhibition and Shows',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'FESTIVAL',
      Description: 'Festivals and Celebrations',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'EVTFOOD',
      Description: 'Food and Wine',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'EVTMARKET',
      Description: 'Markets',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'SPORT',
      Description: 'Sporting Events',
      ProductCategory: 'EVENT',
    },
    {
      ProductTypeId: 'BAR',
      Description: 'Bars',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'BREWERY',
      Description: 'Breweries',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'COOKSCHOOL',
      Description: 'Cooking Schools, Lessons, Workshops',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'PRODUCE',
      Description: 'Produce',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'CAFE',
      Description: 'Restaurant and Cafe',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'WINERY',
      Description: 'Wineries',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'TAKEAWAYS',
      Description: 'Takeaways',
      ProductCategory: 'RESTAURANT',
    },
    {
      ProductTypeId: 'ATM',
      Description: 'ATM',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'ACCOMBOOK',
      Description: 'Accommodation Booking Services',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'ARTISANS',
      Description: 'Artisans',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'BANK',
      Description: 'Bank',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'BUSSTOP',
      Description: 'Bus Stop',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'BEAUTYHAIR',
      Description: 'Beauty & Hair',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'CHILDCARE',
      Description: 'Child Care Service',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'CINEMA',
      Description: 'Cinema',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PUBCARPARK',
      Description: 'Council Public Car Park',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'DENTIST',
      Description: 'Dentist',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'DELIVERY',
      Description: 'Delivery Services',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'DISCRDPRO',
      Description: 'Discount Card Provider',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'DJ',
      Description: "Dj's",
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'FOREX',
      Description: 'Foreign Exchange',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'FUELSTOP',
      Description: 'Fuel Stop',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'GENTOUSER',
      Description: 'General Tourism Services',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'HOSPITAL',
      Description: 'Hospital',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'INTERPRETGUID',
      Description: 'Interpreter Guide',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'MEDCENTRE',
      Description: 'Medical Centre',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'MOTORMECH',
      Description: 'Motor Mechanic',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'MUSICALARTISTS',
      Description: 'Musical Artists',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PARKPASPRO',
      Description: 'Park Pass Provider',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PETCARE',
      Description: 'Pet Care Service',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PHARMACY',
      Description: 'Pharmacy',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PHOTOGRAPHERS',
      Description: 'Photographers',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PLAYGROUN',
      Description: 'Playground',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PRVCARPARK',
      Description: 'Private Car Parking',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PUBLICTEL',
      Description: 'Public Telephone',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PUBTOILATT',
      Description: 'Public Toilet',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'PUBTRANSST',
      Description: 'Public Transport Station',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'SERVST',
      Description: 'Service Station',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'SUPERMKT',
      Description: 'Supermarket',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'TAXIRNK',
      Description: 'Taxi Rank',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'TELECOM',
      Description: 'Telecommunication Services',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'VIDEOGRAPHERS',
      Description: 'Videographers',
      ProductCategory: 'GENSERVICE',
    },
    {
      ProductTypeId: 'WEDSERV',
      Description: 'Wedding Services',
      ProductCategory: 'GENSERVICE',
    },
  ];
  constructor(
    public searchService: SearchService,
    private productService: ProductService,
    private router: Router,
    private translate: TranslateService
  ) {}
  ngOnInit(): void {
    this.categoryTypes = [
      { id: 'ACCOMM', name: 'Accommodations', src: '/assets/images/Accomm_Menu_icon.png' },
      { id: 'ATTRACTION', name: 'Attractions', src: '/assets/images/Attractions_menu_icon.png' },
      { id: 'TOUR', name: 'Activities', src: '/assets/images/Activities_menu_icon.png' },
      { id: 'TRANSPORT', name: 'Airlines', src: '/assets/images/Airlines_menu_icon.png' },
      { id: 'DESTINFO', name: 'Destination Information', src: '/assets/images/island.png' },
      { id: 'EVENT', name: 'Events', src: '/assets/images/Events_menu_icon.png' },
      { id: 'RESTAURANT', name: 'Food & Drinks', src: '/assets/images/Restaurents_menu_icon.png' },
      { id: 'GENSERVICE', name: 'General Services', src: '/assets/images/generalservices.png' },
      { id: 'TOUROPERATOR', name: 'Tour Operators', src: '/assets/images/TourOperator_menu_icon.png' },
      { id: 'ATTRACTION&att=TAGWalks-Trails', name: 'Walks & Trails', src: '/assets/images/Walk_Trails_menu_icon.png' },
    ];

    // Leaflet Map - loaded on demand now instead of globally in index.html
    // (this page is one of only two that ever uses it). selectCategeory()
    // moved inside this callback too since it eventually calls showMarkers(),
    // which uses this.map - without this it could run before the map exists.
    loadLeafletAssets().then(() => {
      this.map = L.map('ll-map').setView([-4.6839, 55.4495], 12);
      const mapLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(this.map);

      this.selectCategeory('ACCOMM', 0, 'Accommodations', '/assets/images/Accomm_Menu_icon.png');
    });

    var language = localStorage.getItem('language');
    this.productService.getPopularSearchKeywords(language).then((res) => {
      this.popularKeywords = res;
    });
  }

  getLabel(key: string) {
    const item = this.subCatNames.find((item) => item.ProductTypeId.toLowerCase() === key.toLowerCase());
    if (item) {
      return item.Description;
    } else {
      return key;
    }
  }

  selectCategeory(categoryType: string, index: any, cat: any, src: any) {
    this.selectedCat.name = cat;
    this.selectedCat.src = src;
    if (this.selectedCatKey === categoryType) {
      this.selectedCatKey = '';
    } else {
      this.selectedCatKey = categoryType;
      this.searchByValue([categoryType]);
      $('#p-panel-' + index + '-titlebar').css({ color: '#00a7a6' });
    }
  }
  openSearchBox() {
    this.showSearchBox = !this.showSearchBox;
    this.searchTxt = '';
    this.newserachResults = [];
  }
  searchByValue(categeoryName: any) {
    this.modelPopUp = false;
    this.subCatKeys = [];
    this.subCat = {};
    this.searchService
      .getMapsListing(categeoryName)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.searchResults = [];
        this.searchResults = data.products;
        this.searchResults.forEach((item: any) => {
          var found = false;
          for (var i = 0; i < item.addresses.length; i++) {
            this.latLongitude = item.addresses[i].geo_location;
            this.latLongitude = this.latLongitude.split(',');
            this.lattitude = this.latLongitude[0];
            this.longitude = this.latLongitude[1];
            if (
              this.lattitude &&
              this.longitude &&
              this.lattitude != '' &&
              this.longitude != '' &&
              this.lattitude != '\n' &&
              this.longitude != '\n'
            ) {
              found = true;
              break;
            }
          }
          if (found && item.productClassifications) {
            item.productClassifications?.forEach((value: any) => {
              const val = value.toLowerCase();
              if (this.subCatKeys.indexOf(val) < 0) {
                this.subCatKeys.push(val);
                this.subCat[val] = [item];
              } else {
                this.subCat[val].push(item);
              }
            });
          }
        });
        //console.log('sub...', this.subCat);
        this.subCatKeys = Object.keys(this.subCat);
        // console.log('subcT....', this.subCatKeys);
        let key = '';
        let results: any = [];
        if (this.subCatKeys.length) {
          key = this.subCatKeys[0];
          results = this.subCat[this.subCatKeys[0]];
        } else {
          results = data.products;
        }
        this.showMarkers(key, results);
      });
  }

  showMarkers(key: string, arr: any) {
    // Defensive guard: the map now loads asynchronously (see ngOnInit), so
    // this could theoretically be called before it's ready.
    if (!this.map) {
      return;
    }
    this.selectedSubCatKey = key;
    this.overlays = [];
    this.leafletMarks = [];
    for (const marker of this.markers) {
      this.map.removeLayer(marker);
    }
    this.markers = [];
    let lat = '';
    let lon = '';
    arr.forEach((el: any) => {
      el.addresses.forEach((ele: any) => {
        el.geo_location = ele.geo_location;
        this.latLongitude = el.geo_location;
        this.latLongitude = this.latLongitude.split(',');
        // if ((this.latLongitude[0] === '') === false && ele.address_type === 'PHYSICAL') {
        this.lattitude = this.latLongitude[0];
        this.longitude = this.latLongitude[1];
        // }
        if (
          this.lattitude &&
          this.longitude &&
          this.lattitude != '' &&
          this.longitude != '' &&
          this.lattitude != '\n' &&
          this.longitude != '\n'
        ) {
          lat = this.lattitude;
          lon = this.longitude;
          let city = '<i class="icon-location"></i>';
          if (ele.city !== '') {
            city = city + ele.city;
          }
          if (ele.island !== '') {
            if (ele.city !== '') {
              city = city + ', ' + ele.island;
            } else {
              city = city + ele.island;
            }
          }
          const title =
            '<div><span class="productname">' +
            el.productName +
            '</span></div>' +
            '<div class="city">' +
            city +
            '</div>';
          const location = {
            productId: el.productId,
            productImage: el.productImage,
            title: title,
            lat: parseFloat(this.lattitude),
            lng: parseFloat(this.longitude),
          };
          this.leafletMarks.push(location);
        }
      });
    });
    if (this.leafletMarks.length) {
      for (const leafletMark of this.leafletMarks) {
        var popup = L.popup().setContent(
          '<div class="map-tooltip">' +
            '<div><img style="width:75px;height:55px;" src="' +
            leafletMark.productImage +
            '" /></div>' +
            '<div>' +
            '<a class="productlink" target="_blank" href="/listingdetails/' +
            leafletMark.productId +
            '">' +
            leafletMark.title +
            '<a class="see-more-details" target="_blank" href="/listingdetails/' +
            leafletMark.productId +
            '">' +
            this.translate.instant('See more details') +
            ' <i class="pi pi-arrow-right"></i></a>' +
            '</div>' +
            '</div>'
        );
        this.map.setView([lat, lon], 12);
        let marker = L.marker([leafletMark.lat, leafletMark.lng]).addTo(this.map);
        marker.bindPopup(popup);
        marker.on('click', (e: any) => {
          var popup = e.target.getPopup();
          var content = popup.getContent();
          this.selectedContent = content;
        });
        marker.on('mouseover', (e: any) => {
          if (!this.isTouchDevice()) {
            marker.openPopup();
          }
        });
        marker.on('mouseout', (e: any) => {
          if (!this.isTouchDevice()) {
            marker.closePopup();
          }
        });
        this.markers.push(marker);
        if (this.selectedCatKey == '') {
          $('#p-panel-0-titlebar').css({ color: '#00a7a6' });
        }
      }
    }
  }

  isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator['msMaxTouchPoints'] > 0;
  }

  showSearchPopup() {
    this.modelPopUp = true;
  }
  closepopup() {
    this.modelPopUp = false;
  }
  navigateToHome() {
    this.router.navigateByUrl('/');
  }
  @HostListener('window:keydown', ['$event']) onMouseEnter(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.modelPopUp) {
      this.selectedCatKey = '';
      this.searchByValue(this.searchQuery);
    }
  }
  search(events: any) {
    let event = events.query.toLowerCase().trim();
    if (event.length >= 1) {
      this.modelPopUp = false;
      this.searchQuery = event;
      this.refFilterResult = [];
      if (this.searchSub) {
        this.searchSub.unsubscribe();
      }
      this.searchSub = this.searchService
        .getSearchInfo(event)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.searchDetails = {};
          this.searchDetails = data;
          this.results = this.searchDetails.products;
          for (let i = 0; i < this.results.length; i++) {
            if (this.results[i].productName.toLowerCase().startsWith(event)) {
              this.refFilterResult.push(this.results[i].productName);
            }
          }
          this.newserachResults = [];
          this.newserachResults = [...new Set(this.refFilterResult)];
        });
    }
  }
  getSearchDetails(selectedTerm: any) {
    this.modelPopUp = false;
    this.selectedCatKey = '';
    this.subCatKeys = [];
    this.subCat = {};
    for (var i = 0; i < this.results.length; i++) {
      if (this.results[i].productName == selectedTerm) {
        this.results[i].addresses[0].geo_location = this.results[i].boundary;
        this.showMarkers(this.results[i].productCategoryId, [this.results[i]]);
        break;
      }
    }
  }

  showSearch() {
    this.showMobileSearch = !this.showMobileSearch;
    this.modelPopUp = true;
    this.searchTxt = [];
    this.newserachResults = [];
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      document.querySelectorAll('.p-panel-toggler').forEach((button) => {
        const expanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-label', expanded ? 'Collapse section' : 'Expand section');
      });
      document.querySelectorAll('.p-panel-toggler').forEach((button) => {
        button.removeAttribute('role');
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
